import * as React from 'react';
import cn from 'classnames';
import * as styles from './ProgramButton.css';
import { LinkButton } from '@cian/ui-kit';
import { MORTGAGE_LINK } from '../../../../constants/suburban';

interface IProgramButtonProps {
  isSticky?: boolean;
  onClick(): void;
}

export const ProgramButton: React.VFC<IProgramButtonProps> = ({ isSticky, onClick }) => (
  <div className={cn(styles['program-button'], isSticky && styles['sticky'])}>
    <LinkButton size="M" fullWidth theme="fill_secondary" href={MORTGAGE_LINK} target="_blank" onClick={onClick}>
      Получить онлайн
    </LinkButton>
  </div>
);
